import { Fragment, useEffect, useState } from "react";
import { Form, Button, FormLabel, FormGroup, FormControl, Row, Col, Table } from "react-bootstrap";
import { Formik, FieldArray } from "formik";
import DatePicker from "react-datepicker";
import * as yup from "yup";
import { useSelector} from "react-redux";
import useFullPageLoader from "app/hooks/useFullPageLoader ";
import Select from 'react-select'
import { useLazyGetCRMCustomerDetailsListQuery } from "app/redux/Customer/customerApi";
import {ArrowLeftCircle, PersonAdd} from "react-bootstrap-icons";
import AddCustomerModal from "app/views/dashboard/modal/AddCustomerModal";
import { format } from "date-fns";
import {useLazyChangeOwnerShipQuery, useLazyUpdateCurrentOwnerShipQuery} from "app/redux/ownership/ownershipApi";
import { toast } from "react-toastify";

export default function AddEditOwnerships({
    show,
    handleFormSubmit,
    toggleEditorDialog,
    ContractId,
    OwnershipId,
    screenType,
    OwnershipDate,
    OwnerShipEndDate,
    initialValues = {}
  }) {

    const [changeOwnerShip] = useLazyChangeOwnerShipQuery();
    const [UpdateCurrentOwnerShip] = useLazyUpdateCurrentOwnerShipQuery();

    const [addCustomerModalState, setAddCustomerModalState] = useState({
        addCustomerdialogValues: null,
        addCustomershowEditorDialog: false
    });

    const addCustomerToggleEditorDialog = (arg) => {
        if (arg && arg.toString()) {
            setAddCustomerModalState((prevState) => ({ ...prevState, addCustomershowEditorDialog: true, addCustomerdialogValues: null }));
        } else {
            setAddCustomerModalState((prevState) => ({
            ...prevState,
            addCustomerdialogValues: null,
            addCustomershowEditorDialog: !addCustomerModalState.addCustomershowEditorDialog
            }));
        }
    };

    const [isFormSubmit, setFormSubmit] = useState(false);
    const [isOwnership100Percent, setIsOwnership100Percent] = useState(false);
    const [loader, showLoader, hideLoader] = useFullPageLoader();
    const [ownershiDetailList, setOwnershiDetailListState] = useState([]);
    const [customerFullDetailList, setCustomerFullDetailListState] = useState([]);
    let [customerDetailList, setCustomerDetailListState] = useState([]);
    let [ownershipDateState, setOwnershipDate] = useState('');
    let [ownershipEndDate, setOwnershipDateState] = useState('');
    const [state, setState] = useState({
      ownershipdate: "",
      ContractHolders: []
    });
    const { selectedCompanyId } = useSelector((state) => state.company);
    const [getCRMCustomerDetailsList] = useLazyGetCRMCustomerDetailsListQuery();

    useEffect(() => {
        fetchCRMCustomerDetailsList(0, screenType);
    }, []);

    const setExistingOwnerData = (customerData) => {
      let ownershipStartDate = format(OwnershipDate, "yyyy-MM-dd");
      setOwnershipDate(ownershipStartDate);
      if(OwnerShipEndDate){
        let tempOwnershipEndDate = format(OwnerShipEndDate, "yyyy-MM-dd");
        setOwnershipDateState(tempOwnershipEndDate);
      }
      
      if(initialValues && initialValues.length > 0){
        initialValues.forEach((item, indx) => {
          if(item.CustomerId){
            setCustomerInOwnership(item.CustomerId, customerData, item.OwnershipPercentage, "Edit", item.IsInvoiceRecipient);
          }
        });
      }
     
    }

    const fetchCRMCustomerDetailsList = async(custId, type="") => {
        showLoader();
        getCRMCustomerDetailsList({
            CompanyId: selectedCompanyId,
            CustomerType: 3,
            IsArchive: false,
            ContractTypeID: 0
          }).then((result) => {
            hideLoader();
            if (result.isSuccess) {
              let tempdata = result.data.data;
              let customerData = tempdata.map((e) => ({
                ...e,
                value: e.CustomerId,
                label: e.ContactName
              }));
              //console.log('customerdata -- ', customerData);
              if(custId && custId !== 0){
                setCustomerInOwnership(custId, customerData, 100, "New");
              }
              setCustomerFullDetailListState(customerData);
              setCustomerDetailListState(customerData);
              if(type === "Edit"){
                setExistingOwnerData(customerData);
              }
            }
          });
    }

    const setCustomerInOwnership = (custId, customerData, OwnershipPercentage, type, IsInvoiceRecipient=false) => {
        if(custId && custId !== 0){
            let selectedCustDetail = customerData.filter(a => a.CustomerId === custId);
            if(selectedCustDetail && selectedCustDetail.length > 0){
                let ownerdet = state.ContractHolders;
                let ownerdetLength = 0;
                if(ownerdet && ownerdet.length > 0){
                  ownerdetLength = ownerdet.length;
                  const chkAlreadyExists = ownerdet.filter(a => a.CustomerID === custId);
                  if(chkAlreadyExists && chkAlreadyExists.length > 0){
                    return;
                  }
                }
                let tempval = {};
                tempval.CustomerID = selectedCustDetail[0].CustomerId
                tempval.OwnershipPercentage = OwnershipPercentage;
                tempval.Name =selectedCustDetail[0].CustomerNickName;
                tempval.Email = selectedCustDetail[0].PrimaryEmail;
                tempval.Phone = selectedCustDetail[0].PrimaryPhone;
                tempval.IsPrivateCustomer = true;
                tempval.CustomerNumber = selectedCustDetail[0].CustomerNumber;
                tempval.customerNickName = selectedCustDetail[0].CustomerNickName;
                tempval.CustomerAccountingId = selectedCustDetail[0].CustomerAccountingId;
                tempval.ContractPerson = selectedCustDetail[0].ContactName;
                tempval.ContactId = selectedCustDetail[0].ContactID;
                tempval.PersonNumber = selectedCustDetail[0].PersonNumber;
                if(type === "Edit"){
                  tempval.IsInvoiced = IsInvoiceRecipient;
                }
                else{
                  tempval.IsInvoiced = ownerdetLength === 0 ? true : false;
                }
                tempval.IsPostalAddress = true;
                tempval.AddressLine1 = selectedCustDetail[0].PrimaryAddressLine1;
                tempval.AddressLine2 = selectedCustDetail[0].PrimaryAddressLine2;
                tempval.PostalCode = selectedCustDetail[0].PrimaryZipCode;
                tempval.City = selectedCustDetail[0].PrimaryCity;
                tempval.Country = selectedCustDetail[0].PrimaryCountry;
                tempval.bankAccountNumber = selectedCustDetail[0].BankAccountNo;
                tempval.IsCustomer = selectedCustDetail[0].IsCustomer;

                ownerdet.push(tempval);
                if(type === "New"){
                  let finalOwnerdet = getOnwerShipPercentage(ownerdet);
                  setState({
                    ContractHolders: finalOwnerdet
                  });
                }
                else{
                  setState({
                    ContractHolders: ownerdet
                  });
                }
                
            }
            
         }
    }

    const handleSubmit = async (values, { setSubmitting }) => {
      showLoader();  
      let isFormValid = true;
        let formInvalidMesaage = "";
        setFormSubmit(true);
        let ownerdet = state.ContractHolders;
        if(checkOwershipPercentageTotal(ownerdet) !== 100){
            setIsOwnership100Percent(false);
            isFormValid = false;
            formInvalidMesaage = "ownership should be 100%";
        }
        else{
            setIsOwnership100Percent(true);
        }

        if(ownershipDateState === ""){
            isFormValid = false;
            formInvalidMesaage = "ownership date cannot be blank";
        }
       
        if(isFormValid && ownerdet && ownerdet.length > 0){
          
          let chkIsInvoiceRecp = ownerdet.filter(a => a.IsInvoiced === true);
          if(chkIsInvoiceRecp && chkIsInvoiceRecp.length === 0){
            ownerdet[0].IsInvoiced = true;
          }
          if(screenType === "Edit"){
              const ContractTypeId = 0;
              const OwnerShipDate = format(ownershipDateState, "yyyy-MM-dd");
              let OwnerShipEndDate = "";
              if(ownershipEndDate !== "" ){
                OwnerShipEndDate = format(ownershipEndDate, "yyyy-MM-dd");
              }
              const MoveInDate = format(ownershipDateState, "yyyy-MM-dd");
              const Price = 0;
              const Notes = "";
              const AddedByPersonID = localStorage.getItem('loginUserPersonId');
              const AddedByUserRoleID = 1;
              const AddedByCompanyId = localStorage.getItem('CompanyId');
              const NoOfOwnership = ownerdet;
              const IsBlankOwnership = false;
              const requestText = "";
              const source = "KeyFree";
              const ReasonToUpdate = "";

              let newFormData = {};
              newFormData.ContractTypeId = ContractTypeId;
              newFormData.ContractId = ContractId;
              newFormData.OwnerShipDate = OwnerShipDate;
              newFormData.OwnerShipEndDate = OwnerShipEndDate;
              newFormData.MoveInDate = MoveInDate;
              newFormData.Price = Price;
              newFormData.Notes = Notes;
              newFormData.AddedByPersonID = AddedByPersonID;
              newFormData.AddedByUserRoleID = AddedByUserRoleID;
              newFormData.AddedByCompanyId = AddedByCompanyId;
              newFormData.NoOfOwnership = NoOfOwnership;
              newFormData.IsBlankOwnership = IsBlankOwnership;
              newFormData.requestText = requestText;
              newFormData.source = source;
              newFormData.ReasonToUpdate = ReasonToUpdate;
              let NoOfOwners = [];
              NoOfOwnership.forEach((item, indx) => {
                let owner = {};
                owner.ContractHolderID = item.CustomerID;
                owner.ContractHolderName = item.CustomerNickName;
                owner.OwnershipPercentage = item.OwnershipPercentage;
                owner.RowID = 0;
                owner.IsInvoiceRecipient = item.IsInvoiced;
                NoOfOwners.push(owner);
              });
              newFormData.NoOfOwnership = NoOfOwners;
              
              await UpdateCurrentOwnerShip(newFormData).then((result) => {
                hideLoader();
                if(result.data.isSuccess){
                  const custId = result.data.data;
                  toast.success("ownership updated successfully", { autoClose: 2000 });
                  handleFormSubmit(custId);
                  toggleEditorDialog();
                }
                else{
                  toast.error(result.data.message, { autoClose: 2000 });
                }
              }, error => {
                hideLoader();
                toast.error(error);
              });
          }
          else{
              const ContractTypeId = 0;
              const OwnerShipDate = format(ownershipDateState, "yyyy-MM-dd");
              const MoveInDate = format(ownershipDateState, "yyyy-MM-dd");;
              const Price = 0;
              const Notes = "";
              const AddedByPersonID = localStorage.getItem('loginUserPersonId');
              const AddedByUserRoleID = 1;
              const AddedByCompanyId = localStorage.getItem('CompanyId');
              const NoOfOwnership = ownerdet;
              const IsBlankOwnership = false;
              const requestText = "";
              const source = "KeyFree";

              let newFormData = {};
              newFormData.ContractTypeId = ContractTypeId;
              newFormData.ContractId = ContractId;
              newFormData.OwnerShipDate = OwnerShipDate
              newFormData.MoveInDate = MoveInDate
              newFormData.Price = Price;
              newFormData.Notes = Notes;
              newFormData.AddedByPersonID = AddedByPersonID;
              newFormData.AddedByUserRoleID = AddedByUserRoleID;
              newFormData.AddedByCompanyId = AddedByCompanyId;
              newFormData.NoOfOwnership = NoOfOwnership;
              newFormData.IsBlankOwnership = IsBlankOwnership;
              newFormData.requestText = requestText;
              newFormData.source = source;
              newFormData.NoOfOwnership = NoOfOwnership;
              
              await changeOwnerShip(newFormData).then((result) => {
                hideLoader();
                if(result.data.isSuccess){
                  const custId = result.data.data;
                  toast.success("ownership created successfully", { autoClose: 2000 });
                  handleFormSubmit(custId);
                  toggleEditorDialog();
                }
                else{
                  toast.error(result.data.message, { autoClose: 2000 });
                }
              }, error => {
                hideLoader();
                toast.error(error);
              });
          }
          
          
        }
        else{
          hideLoader();
          if(!isFormValid){
            toast.error(formInvalidMesaage, { autoClose: 2000 });
          }
        }


    };

    const checkOwershipPercentageTotal = (data) => {
        let totalPerAllocated = 0;
        data.forEach((item, indx) => {
            totalPerAllocated = totalPerAllocated + item.OwnershipPercentage;
        });
        return totalPerAllocated;
    }

    const handleDeleteCustomer = async (itemIndx, customerId) => {
      let ownerdet = state.ContractHolders;
      ownerdet = ownerdet.filter(a => a.CustomerID !== customerId);
      let finalOwnerdet = getOnwerShipPercentage(ownerdet);
      setState({
        ContractHolders: finalOwnerdet
      });
    };

    const onChange = (event) => {
     if(event){
        //console.log('customerdata onChange event -- ', event);
        customerDetailList = customerDetailList.filter(a => a.CustomerId !== event.CustomerId);
        setCustomerDetailListState(customerDetailList);
        let ownerdet = state.ContractHolders;
        let ownerdetLength = 0;
        if(ownerdet && ownerdet.length > 0){
          ownerdetLength = ownerdet.length;
        }
        let tempval = {};
        tempval.CustomerID = event.CustomerId
        tempval.OwnershipPercentage ='100';
        tempval.Name =event.CustomerNickName;
        tempval.Email = event.PrimaryEmail;
        tempval.Phone = event.PrimaryPhone;
        tempval.IsPrivateCustomer = true;
        tempval.CustomerNumber = event.CustomerNumber;
        tempval.customerNickName = event.CustomerNickName;
        tempval.CustomerAccountingId = event.CustomerAccountingId;
        tempval.ContractPerson = event.ContactName;
        tempval.ContactId = event.ContactID;
        tempval.PersonNumber = event.PersonNumber;
        tempval.IsInvoiced = ownerdetLength === 0 ? true : false;
        tempval.IsPostalAddress = true;
        tempval.AddressLine1 = event.PrimaryAddressLine1;
        tempval.AddressLine2 = event.PrimaryAddressLine2;
        tempval.PostalCode = event.PrimaryZipCode;
        tempval.City = event.PrimaryCity;
        tempval.Country = event.PrimaryCountry;
        tempval.bankAccountNumber = event.BankAccountNo;
        tempval.IsCustomer = event.IsCustomer;

        ownerdet.push(tempval);
        let finalOwnerdet = getOnwerShipPercentage(ownerdet);
        setState({
          ContractHolders: finalOwnerdet
        });
     }
    };

    const getOnwerShipPercentage = (data) => {
      const len = data.length;
      const partition = ~~(100/len);
      const lastIndex = len - 1;
      let totalPerAllocated = 0;
      data.forEach((item, indx) => {
        if(indx !== lastIndex){
          item.OwnershipPercentage = partition;
          totalPerAllocated = totalPerAllocated + partition;
        }
        else{
          const lastPartition = 100 - totalPerAllocated;
          item.OwnershipPercentage = lastPartition;
        }
      });
      return data;
    }

    const handleInputChange = (index, event) => {
      const values = state.ContractHolders;
      const updatedValue = event.target.name;
      values[index][updatedValue] = +event.target.value;
  
      setState({
        ContractHolders: values
      });
    };

    const handleInputCheckBoxChange = (index, event) => {
      const values = state.ContractHolders;
      const updatedValue = event.target.name;
      if(event.target.checked === true){
        values.forEach((item, indx) => {
          if(indx !== index){
            item.IsInvoiced = false;
          }
          else{
            item.IsInvoiced = true;
          }
        });
      }
      else{
        values[index][updatedValue] = event.target.checked;
      }
     
      setState({
        ContractHolders: values
      });
    };

    const addCustomerHandleFormSubmit = async (values) => {
        //console.log('addCustomerHandleFormSubmit - ', values);
        fetchCRMCustomerDetailsList(values);
        addCustomerToggleEditorDialog(false);
    };
    

  let { addCustomerdialogValues, addCustomershowEditorDialog } = addCustomerModalState;
  return (
    <div className="invoice-viewer py-3">
      <Formik
        initialValues={state}
        onSubmit={handleSubmit}
        // validationSchema={ownershipValidationSchema}
        enableReinitialize={true}>
        {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue }) => {
          return (
            <Fragment>
              <Form onSubmit={handleSubmit} className="px-3">
                <div className="viewer_actions d-flex align-items-center justify-content-end gap-2 mb-4">
                  <Button
                    type="button"
                    variant="primary"
                    onClick={() => toggleEditorDialog(false)}>
                   <ArrowLeftCircle className={'me-2'} size={17}></ArrowLeftCircle>
                    Tilbake
                  </Button>
                  <Button type="submit" variant="primary">
                    Lagre
                  </Button>
                </div>

                <Row className="justify-content-between">
                  <Col md={6} sm={7}>
                    <h4 className="fw-bold">Nytt eierskap</h4>

                    <FormGroup className="col-md-4 col-sm-7 mb-3">
                      <FormLabel>Eierskapsdato</FormLabel>
                      <DatePicker
                        className="form-control mb-1 w-100"
                        placeholder="Eierskapsdato(DD.MM.YYYY)"
                        dateFormat="dd.MM.yyyy"
                        selected={ownershipDateState ? new Date(ownershipDateState) :''}
                        onChange={(date) => {setFieldValue({ ownershipdate: date }); setOwnershipDate(date);}}
                        onBlur={handleBlur}
                        //isInvalid={errors.ownershipDateState && touched.ownershipDateState}
                        // selected={values.ownershipdate ? new Date(values.ownershipdate) :''}
                        // onChange={(date) => {setFieldValue({ ownershipdate: date }); setOwnershipDate(date);}}
                      />
                       {isFormSubmit && ownershipDateState === "" && (
                          <><br/> <small className="text-danger">ownership date required</small></>
                       )}

                      {/* <FormControl
                        placeholder="Eierskapsdato"
                        name="ownershipdate"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className="px-1 mb-2"
                        value={values.ownershipdate}
                      /> */}
                    </FormGroup>
                  </Col>
                </Row>

                <div className="mt-3 mb-4 border-top" />

                <Row>
                  <FieldArray >
                    {() => (
                      <Col xs={12}>
                        <Table responsive hover className="mb-3">
                          <thead className="bg-gray-300">
                            <tr>
                              <th scope="col">#</th>
                              <th scope="col">Eierandel</th>
                              <th scope="col">Fakturamottaker</th>
                              <th scope="col">Navn</th>
                              <th scope="col">E-post</th>
                              <th scope="col">Telefon</th>
                              <th scope="col"></th>
                            </tr>
                          </thead>
                          <tbody>
                            {values.ContractHolders.map((item, ind) => (
                              <tr key={ind}>
                                <th className="text-middle" scope="row">
                                  {ind + 1}
                                </th>
                                <td>
                                    <FormControl
                                    type="text"
                                    name="OwnershipPercentage"
                                    placeholder="Enter percentage"
                                    value={item.OwnershipPercentage}
                                    onChange={(event) =>
                                        handleInputChange(ind, event)
                                    }
                                    />
                                </td>
                                <td className="text-middle">
                                      <label className="checkbox checkbox-primary form-check-inline" >
                                          <input
                                          type="checkbox"
                                          name="IsInvoiced"
                                          value={item.IsInvoiced}
                                          checked={item.IsInvoiced}
                                          onChange={(event) =>
                                            handleInputCheckBoxChange(ind, event)
                                          }
                                          onBlur={handleBlur}
                                          />
                                          <span className="checkmark"></span>
                                      </label>
                                </td>
                                <td>
                                  <FormControl
                                    value={values.ContractHolders[ind].Name}
                                    name={`ContractHolders[${ind}].Name`}
                                    type="text"
                                    placeholder="Navn"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    
                                  />
                                </td>
                                <td>
                                  <FormControl
                                    value={values.ContractHolders[ind].Email}
                                    name={`ContractHolders[${ind}].Email`}
                                    type="text"
                                    placeholder="e-post"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                  />
                                </td>
                                <td>
                                  <FormControl
                                    value={values.ContractHolders[ind].Phone}
                                    name={`ContractHolders[${ind}].Phone`}
                                    type="text"
                                    placeholder="telefon"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                  />
                                </td>
                                <td>
                                  <button
                                    type="button"
                                    onClick={() => handleDeleteCustomer(ind, item.CustomerID)}
                                    className="btn btn-outline-secondary float-right">
                                    Slett
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>

                        {isFormSubmit && values.ContractHolders.length === 0 ? (
                          <small className="text-danger">Minimum 1 vare kreves | Total eierskapsprosent skal være 100</small>
                        ) :
                          isFormSubmit && !isOwnership100Percent && (
                            <small className="text-danger">Total eierskapsprosent skal være 100</small>
                          )
                        }

                        

                        <Row className="mt-2">
                            <FormGroup as={Col} xs={2} className="d-flex flex-column"> 
                                <Button variant="primary" onClick={addCustomerToggleEditorDialog}>
                                    <PersonAdd className={'me-2'} size={17}></PersonAdd>
                                      Legg til ny eier
                                </Button>
                            </FormGroup> 
                            <FormGroup as={Col} xs={3} className="d-flex flex-column"> 
                                <Select
                                    style={{width:"10px"}}
                                    placeholder={"Velg eksisterende kunde"}
                                    aria-labelledby="aria-label"
                                    inputId="aria-example-input"
                                    name="aria-live-color"
                                    onChange={onChange}
                                    options={customerDetailList}
                                />
                            </FormGroup> 
                        </Row>
                        
                      </Col>
                    )}
                  </FieldArray>
                </Row>
              </Form>
              <AddCustomerModal
                show={addCustomershowEditorDialog}
                initialValues={addCustomerdialogValues}
                handleFormSubmit={addCustomerHandleFormSubmit}
                toggleEditorDialog={addCustomerToggleEditorDialog}
              />
              {loader}
            </Fragment>
          );
        }}
      </Formik>
    </div>
  );
}

